import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoImpactoOrcamentario } from '../models/projeto-impacto-orcamentario.model';

@Injectable()
export class ProjetoImpactoOrcamentarioService extends BaseService<ProjetoImpactoOrcamentario> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/projeto-impacto';
  }
}
